export const groupImage = "https://cdn.magicpatterns.com/uploads/8XULWKVgfrDPwPNpZ5b4PG/MHS04039.jpg";

export const groupName = "Goldfunken – Von der Idee zum Buch";

export const groupBenefits = [
  {
    title: "Wöchentliche Live-Sessions",
    text: "Exklusiv in der Gruppe, zu allen Themen rund ums Buch: Verlagssuche, Fehler, die Du vermeiden solltest, Must-haves für Dein Buch, Flow, Fokus, das richtige Mindset und vieles mehr.",
  },
  {
    title: "Echte Fallbeispiele",
    text: "Zum Beispiel, wie Sani innerhalb von drei Monaten ihren historischen Roman geschrieben hat.",
  },
  {
    title: "Videos und Aufzeichnungen",
    text: "Wertvolle Inhalte, die Du direkt für Dein eigenes Buch anwenden kannst, auch wenn Du einmal live nicht dabei sein konntest.",
  },
  {
    title: "Eine wertschätzende Community",
    text: "Menschen, die den gleichen Traum haben wie Du und endlich dafür losgehen.",
  },
  {
    title: "Einblicke in meinen Alltag als Autorin",
    text: "Exklusiv und ganz persönlich, und noch so viel mehr.",
  },
];
